/**
 * WSR design tokens.
 *
 * Mirrors the design-handoff colors, but the blue family is rebound to the
 * existing app primary (`#2E77D0`) so the WSR view stays visually consistent
 * with the rest of the dashboard. Other accent colors (red/green/amber) and
 * the slate scale come straight from the design.
 */

export const wsrColors = {
  blue: '#2E77D0',
  blue600: '#2362B5',
  blue700: '#133359',
  blue50: '#EBF3FA',

  red: '#EF4444',
  red50: '#FEF2F2',
  redText: '#B91C1C',

  green: '#16A34A',
  green50: '#F0FDF4',

  amber: '#F59E0B',
  amber50: '#FFFBEB',
  amberText: '#A16207',

  orangeText: '#C2410C',
  orange50: '#FFEDD5',

  redPillBg: '#FEE2E2',
  bluePillBg: '#DBEAFE',
  amberPillBg: '#FEF3C7',

  slate50: '#F5F6F8',
  slate100: '#F1F3F6',
  slate200: '#E5E7EB',
  slate300: '#D1D5DB',
  slate400: '#9CA3AF',
  slate500: '#6B7280',
  slate600: '#4B5563',
  slate700: '#374151',
  slate800: '#1F2937',
  slate900: '#111827',
} as const;

export const wsrShadow = '0 1px 2px rgba(15,23,42,.04)';
export const wsrMonoFont = "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace";

export interface WsrPageMeta {
  num: number;
  label: string;
  short: string;
}

export const WSR_PAGES: WsrPageMeta[] = [
  { num: 1, label: 'Executive Summary', short: 'Summary' },
  { num: 2, label: 'Service Health', short: 'Health' },
  { num: 3, label: 'Incidents Overview', short: 'Incidents' },
  { num: 4, label: 'Ticket Analysis', short: 'Tickets' },
  { num: 5, label: 'Resolution & SLA', short: 'SLA' },
  { num: 6, label: 'Backlog & Aging', short: 'Backlog' },
  { num: 7, label: 'Team Performance', short: 'Team' },
  { num: 8, label: 'Risks & Watchlist', short: 'Risks' },
  { num: 9, label: 'Next Week Outlook', short: 'Outlook' },
];
